import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SolarSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SolarSVG;
